// @ts-nocheck
import React, { useState } from "react";
import { Badge } from "@/shared/components/ui/Badge";
import { Button } from "@/shared/components/ui";
import { PrivacyModal } from "@/features/privacy/components/PrivacyModal";
export function ConsentScreen({ onAccept, onDecline, dataCategories, coolingMonths, dpo }) {
  const [agreed, setAgreed] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const cats = dataCategories && dataCategories.length > 0 ? dataCategories : [];
  return (
    <>
      {showPolicy && <PrivacyModal onClose={() => setShowPolicy(false)} coolingMonths={coolingMonths} dpo={dpo}/>}
      <div className="min-h-dvh safe-bottom bg-white flex items-center justify-center p-4">
        <div className="w-full max-w-lg bg-white border border-line rounded-2xl overflow-hidden shadow-sm">
          <div className="bg-brand-600 px-6 py-5">
            <div className="flex items-center gap-2 mb-2"><div className="w-9 h-9 bg-white rounded-lg flex items-center justify-center p-0.5 shadow-sm"><img src="/aira-logo.png" alt="AIRA" className="w-full h-full object-contain" /></div><Badge/></div>
            <h1 className="text-xl font-black text-white">Consent & Privacy Notice</h1>
          </div>
          <div className="p-4 sm:p-6 space-y-3">
            <p className="text-ink-600 text-sm">Data we will process for your recruitment:</p>
            <div className="space-y-2">
              {cats.map(d => (
                <div key={d.id} className="flex gap-3 p-3 rounded-xl border border-line bg-surface-alt">
                  <div className="w-5 h-5 rounded-full bg-brand-50 border border-brand-300 flex items-center justify-center shrink-0 mt-0.5">
                    <svg className="w-3 h-3 text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7"/></svg>
                  </div>
                  <div>
                    <p className="text-ink-900 text-sm font-semibold">{d.label}</p>
                    <p className="text-ink-400 text-xs">{d.items}</p>
                    <p className="text-brand-600 text-xs mt-0.5"><b>Purpose:</b> {d.purpose}</p>
                  </div>
                </div>
              ))}
            </div>
            <label className={`flex gap-3 p-4 rounded-xl border cursor-pointer transition-all mt-4 ${agreed ? "border-brand-500 bg-brand-50" : "border-line bg-surface-alt"}`}>
              <input type="checkbox" checked={agreed} onChange={() => setAgreed(!agreed)} className="mt-0.5 w-5 h-5 accent-brand-600 shrink-0"/>
              <div><p className="text-ink-900 text-sm font-bold">I consent to all of the above</p><p className="text-ink-400 text-xs mt-0.5">I agree to processing of my data and confirm I am 18+</p></div>
            </label>
            <p className="text-ink-400 text-xs">By proceeding you confirm you have read our <button onClick={() => setShowPolicy(true)} className="text-brand-600 underline hover:text-brand-700">Privacy Policy</button>.</p>
            <div className="flex gap-3 pt-1">
              <Button variant="secondary" className="flex-1" onClick={onDecline}>Decline</Button>
              <Button variant="primary" className="flex-1" onClick={() => agreed && onAccept(cats.map(d => d.id))} disabled={!agreed || cats.length === 0}>I Consent →</Button>
            </div>
          </div>
        </div>
      </div>
      <img
        src="/great-place-to-work.png"
        alt="Indira IVF — Great Place To Work Certified, Jan 2026–Jan 2027, India"
        className="hidden sm:block fixed fixed-safe-top-right w-16 md:w-20 h-auto z-10"
        loading="lazy"
      />
    </>
  );
}
